import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import SolicitacoesEmAberto from '../../componentes/envio-imagens/grid-solicitacoes';
import { SttCtrlP } from '@stt-componentes/core';
import { NotificationManager } from 'react-notifications';

const useStyles = makeStyles(theme => ({
    wrapper: {
        padding: theme.spacing(2)
    }
}));

const Solicitacoes = (props) => {
    const { strings } = props;
    const classes = useStyles();

    const callbackImpedirImpressao = () => {
        NotificationManager.error(strings.impedirImpressao);
    };

    return (

        <div className={classes.wrapper}>
            <SttCtrlP callback={callbackImpedirImpressao} />
            <SolicitacoesEmAberto />
        </div>
    );
};

export default Solicitacoes;